import React, { useCallback } from 'react';
import classnames from 'classnames';
import { Icon, Button } from 'tea-component';
import '@gp/components/IconButton/index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

const IconButton: React.FC<any> = (props) => {
  const { disabled, onClick, prefix, suffix, children, className } = props;

  const handleClick = useCallback(() => {
    if (disabled) return;
    if (onClick instanceof Function) {
      onClick();
    }
  }, [disabled, onClick]);

  return (
    <>
      <Button
        className={classnames('dbg-common-iconbtn', className, {
          'is-disabled': disabled,
        })}
        {...props}
        disabled={false}
        onClick={handleClick}
      >
        {prefix && <SvgIcon type={prefix} className="prefix-icon" />}
        {children}
        {suffix && <SvgIcon type={suffix} className="suffix-icon" />}
      </Button>
    </>
  );
};

export default React.memo(IconButton);
